import { render } from "./Notices.vue?vue&type=template&id=4c584dec"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/Notices/Notices.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c584dec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c584dec', __exports__)) {
    api.reload('4c584dec', __exports__)
  }
  
  module.hot.accept("./Notices.vue?vue&type=template&id=4c584dec", () => {
    api.rerender('4c584dec', render)
  })

}


export default __exports__